<template>
    <div>
        <!-- Actions -->
        <div class="float-right">
            <badge type="secondary" style="font-size:1.2rem;" v-if="edit">
                <a href="#" class="text-danger mr-2" @click.prevent="$emit('remove', issue)">
                    <i class="tim-icons icon-simple-remove"></i>
                </a>
                <a href="#" class="text-primary" @click.prevent="$emit('update', issue)">
                    <i class="tim-icons icon-pencil"></i>
                </a>
            </badge>
            <actions-dropdown :actions="actions()" v-else></actions-dropdown>
        </div>

        <div class="issue-title" v-if="issue.entered_at && issue.timeslot_id && scope != 'all'">

            <!-- Entered at -->
            <small class="text-muted">
                <i class="fas fa-pen mr-1"></i>{{ enteredAt(issue) }}
            </small>

        </div>

        <div class="issue-title" :style="edit ? 'min-height:32px;' : ''" v-if="!issue.timeslot_id">

            <!-- Time -->
            <small class="text-muted pb-2 pr-3" v-if="issue.log_time_from">
                <i class="fas fa-clock mr-1"></i>{{ issue.log_time_from }}
                <span v-if="issue.log_time_to"> - {{ issue.log_time_to }}</span>
            </small>

            <!-- Entered at -->
            <small class="text-muted pb-2" v-if="issue.entered_at && scope != 'all'">
                <i class="fas fa-pen mr-1"></i>{{ enteredAt(issue) }}
            </small>

            <!-- Summary -->
            <h6 class="text-sm mb-1" v-if="issue.summary">
                {{ issue.summary }}
            </h6>
        </div>

        <!-- Note -->
        <!-- Keep it one 1 line -->
        <p class="description mt-2">{{ issue.description }}</p>

        <!-- Author -->
        <small class="d-block mt-3 text-primary" v-if="scope == 'all'">
            <em>-- {{ issue.author.name }}</em>
            <em class="pl-2" v-if="issue.entered_at">({{ enteredAt(issue) }})</em>
            <em class="pl-2" v-else>({{ date(issue.updated_at) }})</em>
        </small>

        <!-- Status -->
        <div class="mb-1" v-if="issue.status">
            <small>
                <badge class="mr-1" :type="statusColor(issue.status.value)">{{ statusText(issue.status.value) }}</badge>
                <i class="text-muted">{{ issue.status.author_name }} ({{ issue.status.date }})</i>
            </small>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {

        props: {

            issue: {
                type: Object,
                required: true
            },

            edit: {
                type: Boolean,
                default: false
            },
            
            scope: {
                type: String,
                default: 'mine'
            },
        },

        data() {
            return {
                moment: moment,
            }
        },

        methods: {

            statusColor(value) {
                if (value == 'confirmed') {
                    return 'warning'
                }
                if (value == 'solved') {
                    return 'success'
                }
                if (value == 'closed') {
                    return 'secondary'
                }
            },

            statusText(value, withPrefix = false) {
                let prefix = withPrefix ? this.$t('issues.status-prefix') : ''
                if (value == 'none') {
                    return prefix + this.$t('issues.status-no')
                }
                if (value == 'confirmed') {
                    return prefix + this.$t('issues.status-confirmed')
                }
                if (value == 'solved') {
                    return prefix + this.$t('issues.status-solved')
                }
                if (value == 'closed') {
                    return prefix + this.$t('issues.status-closed')
                }
            },

            actions() {
                return [
                    {
                        label: this.statusText('confirmed', true),
                        handler: this.changeStatus,
                        data: 'confirmed'
                    },
                    {
                        label: this.statusText('solved', true),
                        handler: this.changeStatus,
                        data: 'solved'
                    },
                    {
                        label: this.statusText('closed', true),
                        handler: this.changeStatus,
                        data: 'closed'
                    },
                    {
                        label: this.statusText('none', true),
                        handler: this.changeStatus,
                        data: 'none'
                    },
                    {
                        label: this.$t('issues.delete'),
                        handler: this.deleteIssue,
                    }
                ]
            },

            deleteIssue() {
                this.$emit('remove', this.issue)
            },

            changeStatus(status) {
                let issue = {...this.issue}
                issue.status = status
                this.$emit('save', issue)
            },

            date(date) {
                return this.moment(date).format('YYYY/MM/DD')
            },

            enteredAt(issue) {
                return this.moment(issue.entered_at).format('YYYY/MM/DD') + ' at ' + this.moment(issue.entered_at).format('HH:mm')
            }
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    .issue-title >>> .badge-secondary {
        background-color: #ddd;
        color: #444;
    }

</style>
